// Generated by ReScript, PLEASE EDIT WITH CARE

import * as JsxRuntime from "react/jsx-runtime";
import * as BsCssJs$PrezzeeRibbon from "../../../bindings/BsCss/BsCssJs.bs.js";
import * as Kontent$PrezzeeRibbon from "../Kontent/Kontent.bs.js";
import * as Theme__Color$PrezzeeRibbon from "../../../theme/Theme__Color.bs.js";
import * as Theme__Typography$PrezzeeRibbon from "../../../theme/Theme__Typography.bs.js";

var hiLine = BsCssJs$PrezzeeRibbon.merge([
      Theme__Typography$PrezzeeRibbon.Styles.smallBody,
      BsCssJs$PrezzeeRibbon.style([
            BsCssJs$PrezzeeRibbon.color(Theme__Color$PrezzeeRibbon.Personal.primaryRed),
            BsCssJs$PrezzeeRibbon.lineHeight(BsCssJs$PrezzeeRibbon.px(14)),
            BsCssJs$PrezzeeRibbon.padding2(BsCssJs$PrezzeeRibbon.px(12), BsCssJs$PrezzeeRibbon.px(14))
          ])
    ]);

var Styles = {
  hiLine: hiLine
};

function ProfileMenu__HiLine(props) {
  return JsxRuntime.jsx(Kontent$PrezzeeRibbon.Consumer.make, {
              children: JsxRuntime.jsx("div", {
                    children: props.children,
                    className: hiLine
                  })
            });
}

var make = ProfileMenu__HiLine;

export {
  Styles ,
  make ,
}
/* hiLine Not a pure module */
